"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.ListItemProvider = exports.useListItemContext = exports.StyledListItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_1 = require("./styled");
Object.defineProperty(exports, "StyledListItem", { enumerable: true, get: function () { return styled_1.StyledListItem; } });
const context_1 = require("./context");
Object.defineProperty(exports, "useListItemContext", { enumerable: true, get: function () { return context_1.useListItemContext; } });
Object.defineProperty(exports, "ListItemProvider", { enumerable: true, get: function () { return context_1.ListItemProvider; } });
const ListItem = ({ account, contract, children }) => {
    const context = (0, context_1.useListItemContext)();
    (0, react_1.useEffect)(() => {
        if (!context || !account || !contract)
            return;
        void context.callback({ address: contract.address, account }).then(json => {
            context.setCallbackResponse(prevState => ({ ...prevState, [contract.id]: json }));
        });
    }, [contract, account]);
    return (0, jsx_runtime_1.jsx)(styled_1.StyledListItem, { children: children });
};
exports.ListItem = ListItem;
//# sourceMappingURL=index.js.map